import React, { useCallback, useContext } from 'react'
import PropTypes from 'prop-types'
import { get, set, identity } from 'lodash'

import TextInput from '../../TextInput'
import FilterBarContext from '../context'
import { findSectionElement } from '../utils'

const Number = ({ hierarchy, onChange }) => {
  const { filters } = useContext(FilterBarContext)
  const value = get(filters, hierarchy)

  const onChangeHandler = useCallback(
    ({ target: { value } }) => {
      onChange((filters, newSections) => {
        const clonedFilters = { ...filters }
        const newValue = parseFloat(value)

        set(clonedFilters, hierarchy, newValue)

        const clonedNewSections = [...newSections]
        const sectionElement = findSectionElement(clonedNewSections, hierarchy)

        // save only as value key
        delete sectionElement.elements[0].val
        sectionElement.elements[0].value = newValue

        return { clonedFilters, clonedNewSections }
      }, hierarchy)
    },
    [onChange, hierarchy]
  )

  return (
    <TextInput
      id={hierarchy}
      type='number'
      labelText=''
      value={value}
      onChange={onChangeHandler}
    />
  )
}

Number.propTypes = {
  onChange: PropTypes.func,
  hierarchy: PropTypes.arrayOf(PropTypes.string)
}

Number.defaultProps = {
  onChange: identity,
  hierarchy: []
}

export default React.memo(Number)
